<script>
  import { getBrand } from "$lib/utils/getBrand";
  import { getProductName } from "$lib/utils/getProductName";
  import { parsePrice } from "$lib/utils/parsePrice";
  import AddToBag from "$lib/components/global/AddToBag.svelte";

  import NaPicture from "./NA_Picture.svelte";

  /**@type {import("$lib/types").PublicProduct}*/
  export let product;
  /**@type {number}*/
  let viewportHeight;
</script>

<svelte:window bind:innerHeight={viewportHeight} />

<div class="card-container" class:keyboardCard={viewportHeight <= 350}>
  <div
    class="product-container"
    class:out={!product?.isInStock}
    class:withoutOffer={product?.discount == 0}
  >
    <div class="offer-container">
      {#if product?.discount > 0}
        <div class="offer-label">
          <span>
            <strong>
              {`${parseInt(String(product?.discount * 100))}% OFF`}
            </strong>
          </span>
        </div>
      {/if}
    </div>
    <div class="add-to-cart-container">
      <div class="add-to-cart">
        {#if product?.isInStock === true}
          <AddToBag {product} />
        {/if}
      </div>
    </div>
    <a
      aria-label="Go to {product?.name}"
      aria-labelledby="product-label{product?.id}"
      href={`/products/${product?.url}/${product?.sku}`}
      class="image-container"
    >
      <div class={product?.images?.swatch ? "image active" : "image"}>
        {#if product?.images?.image}
          <NaPicture
            width={"360"}
            alt={product?.name}
            source={product?.images?.image}
            borderRadius={12}
          />
        {:else}
          <div class="no-found">
            <NaPicture
              width={"360"}
              alt={product?.name}
              source={"/images/global/bottle.svg"}
              borderRadius={12}
            />
          </div>
        {/if}
      </div>
      {#if product?.images?.swatch}
        <div class="image hover">
          <NaPicture
            width={"360"}
            alt={product?.name}
            source={product?.images?.swatch}
            borderRadius={12}
          />
        </div>
      {/if}
    </a>
    <a
      aria-label="Go to {product?.name}"
      aria-labelledby="product-label{product?.id}"
      href={`/products/${product?.url}/${product?.sku}`}
      class="information"
    >
      <div class="brand-container">
        <span class="red">{getBrand(product?.sku)}</span>
        <span>{product?.sku}</span>
      </div>
      <div class="name">
        <p>{getProductName(product)}</p>
      </div>
      <div class="bottom-information">
        {#if product?.isInStock === false}
          <div class="out-stock">
            <p>Out of Stock</p>
          </div>
        {:else}
          <div class="price">
            <span class:special={product?.specialPrice !== ""}>
              {parsePrice("USD", "en-us", product?.price)}
            </span>
            {#if product?.specialPrice !== ""}
              <span class="special-price">
                {parsePrice("USD", "en-us", product?.specialPrice)}
              </span>
            {/if}
          </div>
        {/if}
      </div>
    </a>
  </div>
  <span id="product-label{product?.id}" class="label"
    >Go to {product?.name}</span
  >
</div>

<style>
  a {
    text-decoration: none;
    color: #000;
  }
  .card-container {
    width: 100%;
    height: 100%;
    box-shadow: var(--shadow-box);
    border-radius: 10px;
    background-color: #fdfdfd;
    user-select: none;
  }
  .product-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .withoutOffer {
    padding-top: 15px;
  }
  .product-container .image-container {
    width: 100%;
    height: 120px;
    overflow: hidden;
  }

  .add-to-cart-container {
    padding-right: 12px;
  }
  .add-to-cart {
    transform: scale(0.8);
  }
  .offer-container {
    width: 100%;
    height: 100%;
  }
  .offer-label {
    width: fit-content;
    height: 30px;
    color: #fdfdfd;
    border-radius: 12px 0 20px 0;
    display: flex;
    align-items: center;
    padding: 0 26px 0 13px;
    background-color: #fa024e;
  }
  .offer span strong {
    font-weight: 900;
  }
  .image {
    width: 100%;
    height: 120px;
    transition: all 0.2s ease;
  }
  .no-found {
    width: 80%;
    height: 80%;
    margin: auto;
  }
  .active {
    transform: translate(0, 0);
  }
  .hover {
    transform: translate(100%, -100%);
  }
  .image-container:hover .active {
    transform: translate(-100%, 0);
  }
  .image-container:hover > .hover {
    transform: translate(0, -100%);
  }
  .information {
    width: 100%;
    height: 100%;
    padding: 0 15px 20px 15px;
  }
  .information .brand-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-transform: capitalize;
    letter-spacing: 0px;
    margin: 15px 0;
    font-weight: 300;
    font-family: "gotham-book";
  }
  .information .brand-container span {
    font-size: 0.75em;
  }
  .information .brand-container .red {
    color: #bf0000;
    letter-spacing: 0px;
    font-size: 0.8em;
  }
  .information .name {
    height: 1.8em;
  }
  .information .name p {
    font-family: "gotham-medium";
    letter-spacing: 0px;
    line-height: 1.1;
    font-size: 0.95em;
    text-transform: uppercase;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    box-orient: vertical;
    overflow: hidden;
  }

  .bottom-information {
    margin: 15px 0 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .bottom-information .price {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    font-weight: 300;
    font-size: 1.1em;
    line-height: 1;
    font-family: "gotham-book";
  }
  .bottom-information .special {
    position: relative;
    font-family: "gotham-book";
  }
  .bottom-information .special-price {
    font-size: 1.1em;
    line-height: 1;
    font-weight: 900;
    color: #fa024e;
    font-family: "gotham-book";
  }
  .bottom-information .special::before {
    content: "";
    width: 60px;
    height: 1.5px;
    background-color: #000;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .out-stock {
    margin: 15px 0 0 0;
  }
  .out {
    padding-top: 50px;
  }
  .keyboardCard {
    width: 180px;
    height: 200px;
  }
  .keyboardCard > .product-container > .image-container {
    width: 100%;
    height: 80px;
  }
  .keyboardCard > .product-container > .image-container > .image {
    height: 80px;
  }
  .keyboardCard .information .brand-container .red {
    font-size: 0.6rem;
  }
  .keyboardCard .information .brand-container span {
    font-size: 0.6rem;
  }
  .keyboardCard .information .name p {
    font-size: 0.8rem;
  }
</style>
